import { managersConstant } from "@constants";
import {apiCaller} from "@utils";

//Case - Case Managers - Load
export const actLoadManagers = (id) => {
    const isLoading = true;
    return dispatch => {
        dispatch(request(isLoading));
        return apiCaller(`/api/teach/managers/case/${id}/`, 'GET', null).then(res => {
            const data = res && res.data;
            if(res && res.status === 200) {
                dispatch(success(data));
            } else {
                dispatch(failure("error"));
            }
        });
    };
    function request(isLoading) { return { type: managersConstant.LOAD_MANAGERS_REQUEST, isLoading } }
    function success(data) { return { type: managersConstant.LOAD_MANAGERS_SUCCESS, payload: data } }
    function failure(error) { return { type: managersConstant.LOAD_MANAGERS_FAILURE, error: error } }
}

//Case - Case Managers - Enroll
export const actAddManagers = (id, params) => {
    const isLoading = true;
    return dispatch => {
        dispatch(request(isLoading));
        return apiCaller(`/api/teach/managers/case/${id}/`, 'PUT', params).then(res => {
            const data = res && res.data;
            if(data) {
                dispatch(success(data));
            } else {
                dispatch(failure("error"));
            }
        });
    };
    function request(isLoading) { return { type: managersConstant.ADD_MANAGERS_REQUEST, isLoading } }
    function success(data) { return { type: managersConstant.ADD_MANAGERS_SUCCESS, payload: data } }
    function failure(error) { return { type: managersConstant.ADD_MANAGERS_FAILURE, error: error } }
}

//Case - Case Managers - Enroll
export const loadCandidatesOfManagers = (id, params) => {
    const isLoading = true;
    return dispatch => {
        dispatch(request(isLoading));
        return apiCaller(`/api/teach/managers/case/${id}/`, 'PUT', params).then(res => {
            const data = res && res.data;
            if(data) {
                dispatch(success(data));
            } else {
                dispatch(failure("error"));
            }
        });
    };
    function request(isLoading) { return { type: managersConstant.LOAD_CANDIDATES_FOR_MANAGERS_REQUEST, isLoading } }
    function success(data) { return { type: managersConstant.LOAD_CANDIDATES_FOR_MANAGERS_SUCCESS, payload: data } }
    function failure(error) { return { type: managersConstant.LOAD_CANDIDATES_FOR_MANAGERS_FAILURE, error: error } }
}

//Case - Case Managers - Remove
export const actRemoveManagers = (id, params) => {
    const isLoading = true;
    return dispatch => {
        dispatch(request(isLoading));
        return apiCaller(`/api/teach/managers/case/${id}/`, 'PUT', params).then(res => {
            const data = res && res.data;
            if(data) {
                dispatch(success(data));
            } else {
                dispatch(failure("error"));
            }
        });
    };
    function request(isLoading) { return { type: managersConstant.REMOVE_MANAGERS_REQUEST, isLoading } }
    function success(data) { return { type: managersConstant.REMOVE_MANAGERS_SUCCESS, payload: data } }
    function failure(error) { return { type: managersConstant.REMOVE_MANAGERS_FAILURE, error: error } }
}